import * as React from "react";
import { Redirect } from "react-router-dom";
import MainLayout from "./layouts/main";
import EmptyLayout from "./layouts/empty";

import { useAuth } from "./auth";
import { isLeadership } from "./lib/access";
import Login from "./pages/login";
import Home from "./pages/home";
import CoachDashboard from "./pages/coach-dashboard";
import User from "./pages/user";
import Exercises from "./pages/exercises";
import EditExercises from "./pages/exercises/edit";
import Create from "./pages/create-workout";
import EditNewWorkout from "./pages/create-workout/edit";

import homeStyles from "./pages/home/home.module.css";
import exercisesStyles from "./pages/exercises/exercises.module.css";

// Pilot routing: leadership lands on the coach dashboard, everyone else
// keeps their pre-existing /users landing so their workflows are
// unchanged. See src/lib/access.ts.
const RootRedirect = () => {
  const { user } = useAuth();
  return isLeadership(user?.email) ? (
    <Redirect to="/dashboard" />
  ) : (
    <Redirect to="/users" />
  );
};

// /dashboard direct hits by non-leadership users redirect to /users so
// they can't reach the dashboard surface even if they type the URL.
// Combined with hiding the sidebar link, the dashboard is invisible to
// non-leadership.
const DashboardGuard = () => {
  const { user } = useAuth();
  if (!isLeadership(user?.email)) return <Redirect to="/users" />;
  return <CoachDashboard />;
};

export interface IRoute {
  path: string;
  exact: boolean;
  isPrivate: boolean;
  Layout: Function;
  Component: Function;
  layoutClass?: string;
  headerClass?: string;
  pageTitle?: string;
  goBack?: string;
  containerClass?: string;
  useOwnHeader?: boolean;
}

const routes: IRoute[] = [
  {
    path: "/",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: RootRedirect
  },
  {
    path: "/dashboard",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: DashboardGuard,
    pageTitle: "Dashboard"
  },
  {
    path: "/users",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: Home,
    pageTitle: "Users",
    containerClass: homeStyles.homeContainer
  },
  {
    path: "/users/:id",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: User,
    pageTitle: "User's profile",
    goBack: "/users"
  },
  {
    path: "/users/:id/workout/edit/:workoutId",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: Exercises,
    useOwnHeader: true,
    containerClass: exercisesStyles.exercisesContainer
  },
  {
    path: "/users/:id/workout/edit/:workoutId/edit",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: EditExercises,
    useOwnHeader: true,
    containerClass: exercisesStyles.exercisesEditContainer
  },
  {
    path: "/users/:id/workout/create",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: Create,
    pageTitle: "Create workout"
  },
  {
    path: "/users/:id/workout/edit",
    exact: true,
    isPrivate: true,
    Layout: MainLayout,
    Component: EditNewWorkout,
    pageTitle: "Edit new workout"
  },
  {
    path: "/login",
    exact: true,
    isPrivate: false,
    Layout: EmptyLayout,
    Component: Login
  }
];

export default routes;
